import $ from 'jquery'
import PictureUploader from '@utils/js/picture-uploader'
import SignatureForm from '@utils/js/signature-form'


$(document).ready(function() {

    $('.picture-uploader').each(function(){
        let p = new PictureUploader(this)
        if (window.I18N_TRANSLATION != undefined) {
        	p.seti18n(window.I18N_TRANSLATION)
    	}
    })

    $('.signature-form').each(function(){
        new SignatureForm(this)
    })

});


// WEBPACK FOOTER //
// ./accounts/client/static/js/apps.js